import api from "@core/plugins/api";
import { SanitationHelper } from "@core/helpers";

const cguTextUrl = () => `cgu`;
const confidentialityTextUrl = () => `confid`;

/**
 * cgu service
 * @export
 * @class CguService
 */
export class CguService {
  /**
   * Retrieve cgu text
   * @static
   * @returns {String} Sanitized Html
   */
  static async cguText() {
    try {
      const response = await api.public.get(cguTextUrl());
      const sanitizedCGU = response && SanitationHelper.sanitize(response.data);
      return sanitizedCGU;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Retrieve confidentiality text
   * @static
   * @returns {String} Sanitized Html
   */
  static async confidentialityText() {
    try {
      const response = await api.public.get(confidentialityTextUrl());
      const sanitizedConfidentiality = response && SanitationHelper.sanitize(response.data);
      return sanitizedConfidentiality;
    } catch (error) {
      throw error;
    }
  }
}
